import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

import { Check as IconCheck } from '../icons';
import { cn } from '../../utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    hasError?: boolean;
  }
>(({ className, hasError, ...props }, ref) => (
  <CheckboxPrimitive.Root
    className={cn(
      'peer text-contrast size-4 shrink-0 rounded-[4px] border border-border-default ring-offset-background focus-visible:outline-none focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-surface',
      hasError && 'border-critical',
      className,
    )}
    ref={ref}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      <IconCheck className="h-3.5 w-3.5" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
